import React, {useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import Agenda from './components/agenda'
import Voting from './components/voting'
import Question from './components/questions'
import Downloads from './components/downloads'
import QuestionForm from './components/question_form'
import Chat from './components/chat'
import { setActiveTab } from './actions'
import RenderedHtmlContent from 'src/shared/virtual_congress/components/rendered_html_content'

import icon_agenda_grey from 'video_room/sug_icon-agenda-grey.png'
import icon_agenda_white from 'video_room/sug_icon-agenda-white.png'
import icon_files_grey from 'video_room/sug_icon-files-grey.png'
import icon_files_white from 'video_room/sug_icon-files-white.png'
import icon_question_white from 'video_room/sug_icon-question-white.png'
import icon_question_grey from 'video_room/sug_icon-question-grey.png'
import HtmlContent from "../../../html_content";
import useTranslation from "../../../virtual_congress/effects/use_translation";

export const NavigationTab = (props) => {
  const {identifier, hidden} = props
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab)

  if (hidden) {
    return null
  }

  return <li id={"tab_" + identifier} className={classNames("nav-item", {active: activeTab === identifier})} onClick={() => dispatch(setActiveTab(identifier))}>
    <div className={classNames("nav-link", {active: activeTab === identifier})}>
      {props.children}
    </div>
  </li>
}

export const Navigation = (props) => {
  return <ul className="nav nav-tabs nav-fill video-room-navigation">
    {props.children}
  </ul>
}

export default function VideoRoomTabs({
  videoRoom,
  useBootstrapNavigation,
  navigationOptions,
  hideNavigationIcons,
  questionsRepeatNames,
  questionsShowCompany,
  chatOptions,
  showQuestionUpVote,
  onVisibleTabsChanged,
  ...props
}) {
  const dispatch = useDispatch()

  const activeTab = useSelector((state) => state.activeTab)
  const activeEvent = useSelector((state) => state.events.find(event => event.id == videoRoom.active_event_id))

  const selectFirstVisibleTab = props.selectFirstVisibleTab !== false

  const showAgenda = activeEvent.video_take_settings_from_video_room ? videoRoom.agenda_enabled : activeEvent.video_agenda_enabled
  const showChat = chatOptions?.enabled != false && ( activeEvent.video_take_settings_from_video_room ? videoRoom.chat_enabled : activeEvent.video_chat_enabled)
  const showDownloads = activeEvent.video_take_settings_from_video_room ? videoRoom.downloads_enabled : activeEvent.video_downloads_enabled
  const showQuestions = (activeEvent.video_take_settings_from_video_room ? videoRoom.questions_enabled : activeEvent.video_questions_enabled) && props.questionsOptions?.enabled != false
  const showQuestionForm = (activeEvent.video_take_settings_from_video_room ? videoRoom.question_form_enabled : activeEvent.video_question_form_enabled) && props.questionFormOptions?.enabled != false
  const showVotings = (activeEvent.video_take_settings_from_video_room ? videoRoom.votings_enabled : activeEvent.video_votings_enabled) && props.votingOptions?.enabled != false && (!videoRoom.voting_render_type || videoRoom.voting_render_type === "sidebar")

  const t = useTranslation(null, true)

  const tabVisibilities = [
    {identifier: "Agenda", isVisible: showAgenda},
    {identifier: "Downloads", isVisible: showDownloads},
    {identifier: "Voting", isVisible: showVotings},
    {identifier: "Question", isVisible: showQuestions || showQuestionForm},
    {identifier: "Chat", isVisible: showChat},
  ]

  useEffect(() => {
    if (selectFirstVisibleTab) {

      if (props.additionalTabs) {
        props.additionalTabs.forEach((additionalTab) => {
          console.log(additionalTab)
          tabVisibilities.push({identifier: additionalTab.identifier, isVisible: !additionalTab.hidden})
        })
      }

      const isActiveTabVisible = _.some(tabVisibilities, function(o) { return activeTab == o.identifier && o.isVisible; });
      if (!isActiveTabVisible) {
        const firstVisibleTab = _.find(tabVisibilities, function(o) { return o.isVisible; });

        if (firstVisibleTab) {
          dispatch(setActiveTab(firstVisibleTab.identifier))
        }
      }
    }
  }, [activeTab, selectFirstVisibleTab, JSON.stringify(tabVisibilities), props.additionalTabs])

  useEffect(() => {
    if (onVisibleTabsChanged) {
      console.log({tabVisibilities})
      onVisibleTabsChanged(tabVisibilities);
    }
  }, [JSON.stringify(tabVisibilities)])

  const AgendaRenderer = (subprops) => {
    if(props.agendaRenderer) {
      let AgendaComponent = props.agendaRenderer
      return <AgendaComponent {...subprops}/>
    }

    if (useBootstrapNavigation) {
      return <NavigationTab identifier={"Agenda"}>
        {!hideNavigationIcons && <><img className="navimg" src={activeTab == "Agenda" ? icon_agenda_white : icon_agenda_grey}/><br/></>}
        <span className="navitem-label">{videoRoom.navigation_agenda_text || t("video_room.agenda.label") || "Agenda"}</span>
      </NavigationTab>
    }

    return <a className={classNames("btn btn-block btn-agenda btn-nav", { active: activeTab == "Agenda"})} {...subprops}>
      {!hideNavigationIcons && <img className="navimg" src={activeTab == "Agenda" ? icon_agenda_white : icon_agenda_grey}/>}
      <span className="navitem-label">{videoRoom.navigation_agenda_text || t("video_room.agenda.label") || props.agendaLabel || "Agenda"}</span>
    </a>;
  }

  const AdditionalTabs = ({additionalTabs, hideNavigationIcons, useBootstrapNavigation}) => {
    const dispatch = useDispatch()
    const activeTab = useSelector((state) => state.activeTab)

    if (!additionalTabs || !Array.isArray(additionalTabs)) {
      return null
    }

    if (useBootstrapNavigation) {
      return additionalTabs.map((additionalTab) => <NavigationTab key={additionalTab.identifier} hidden={additionalTab.hidden} identifier={additionalTab.identifier}>
        {!hideNavigationIcons && <><img className="navimg" src={activeTab == additionalTab.identifier ? additionalTab.iconActive : additionalTab.icon}/><br/></>}
        <span className="navitem-label">{additionalTab.label}</span>
      </NavigationTab>)
    }

    return additionalTabs.filter(additionalTab => !additionalTab.hidden).map((additionalTab) => <div key={additionalTab.identifier} className={classNames("col text-center")}>
      <a className={classNames(`btn btn-block btn-${additionalTab.identifier} btn-nav`, { active: activeTab == additionalTab.identifier})} onClick={() => dispatch(setActiveTab(additionalTab.identifier))}>
        {!hideNavigationIcons && <img className="navimg" src={activeTab == additionalTab.identifier ? additionalTab.iconActive : additionalTab.icon}/>}
        <span className="navitem-label">{additionalTab.label}</span>
      </a>
    </div>)
  }

  const AdditionalContentes = ({additionalTabs}) => {
    const activeTab = useSelector((state) => state.activeTab)

    if (!additionalTabs || !Array.isArray(additionalTabs)) {
      return null
    }

    return additionalTabs.filter(additionalTab => !additionalTab.hidden).filter(additionalTab => activeTab == additionalTab.identifier).map((additionalTab) => additionalTab.render())
  }

  let navigation = useBootstrapNavigation ? <div className="row nav-row"><div className="col-12">
        <Navigation>
        {showAgenda && <AgendaRenderer onClick={() => dispatch(setActiveTab('Agenda'))}/>}
        <NavigationTab key="bsnavigation" hidden={!showDownloads} identifier={"Downloads"}>
          {!hideNavigationIcons && <><img className="navimg" src={activeTab == "Downloads" ? icon_files_white : icon_files_grey}/><br/></>}
          Downloads
        </NavigationTab>
        <NavigationTab key="votingsnavigation" hidden={!showVotings} identifier={"Voting"}>
          {!hideNavigationIcons && <><img className="navimg" src={activeTab == "Voting" ? icon_files_white : icon_files_grey}/><br/></>}
          <span className="navitem-label">{videoRoom.navigation_voting_text || t("video_room.votings.label") || props.votingOptions?.label  || "Votings"}</span>
        </NavigationTab>
        <NavigationTab hidden={!showQuestions && !showQuestionForm} identifier={"Question"}>
          {!hideNavigationIcons && <><img className="navimg" src={activeTab == "Question" ? icon_question_white : icon_question_grey}/><br/></>}
          <span className="navitem-label">{videoRoom.navigation_question_text ||  t("video_room.questions.label") || props.questionOptions?.label || props.questionsLabel || "Questions"}</span>
        </NavigationTab>
        <NavigationTab hidden={!showChat} identifier={"Chat"}>
          {!hideNavigationIcons && <><img className="navimg" src={activeTab == "Chat" ? icon_question_white : icon_question_grey}/><br/></>}
          <span className="navitem-label">{videoRoom.navigation_chat_text ||  t("video_room.chat.label")  ||  props.chatOptions?.label || props.chatLabel ||"Chat"}</span>
        </NavigationTab>

        <AdditionalTabs useBootstrapNavigation={true} additionalTabs={props.additionalTabs} hideNavigationIcons={hideNavigationIcons}/>
      </Navigation></div></div>
    :
    <div className="row sidebar-nav row-navigation">
      <div className="col">
         <div className="row">
          {showAgenda &&
            <div className={classNames("col text-center")}>
              <AgendaRenderer onClick={() => dispatch(setActiveTab('Agenda'))}/>
            </div>
          }
          {showDownloads &&
            <div className={classNames("col text-center")}>
              <a className={classNames("btn btn-block btn-download btn-nav", { active: activeTab == "Downloads"})} onClick={() => dispatch(setActiveTab('Downloads'))}>
                {!hideNavigationIcons && <img className="navimg" src={activeTab == "Downloads" ? icon_files_white : icon_files_grey}/>}
                Downloads
              </a>
            </div>
          }
          {(showQuestions || showQuestionForm) &&
            <div className={classNames("col text-center")}>
              <a className={classNames("btn btn-block btn-question btn-nav", { active: activeTab == "Question"})} onClick={() => dispatch(setActiveTab('Question'))}>
                {!hideNavigationIcons && <img className="navimg" src={activeTab == "Question" ? icon_question_white : icon_question_grey}/>}
                <span className="navitem-label">{videoRoom.navigation_question_text || t("video_room.questions.label") || props.questionsOptions?.label || props.questionsLabel ||  "Questions"}</span>
              </a>
            </div>
          }
          {showVotings &&
            <div className={classNames("col text-center")}>
              <a className={classNames("btn btn-block btn-download btn-nav", { active: activeTab == "Voting"})} onClick={() => dispatch(setActiveTab('Voting'))}>
                {!hideNavigationIcons && <img className="navimg" src={activeTab == "Voting" ? icon_question_white : icon_question_grey}/>}
                { videoRoom.navigation_voting_text || t("video_room.votings.label") ||  props.votingOptions?.label || "Votings"}
              </a>
            </div>
          }
          <AdditionalTabs useBootstrapNavigation={useBootstrapNavigation} additionalTabs={props.additionalTabs} hideNavigationIcons={hideNavigationIcons}/>
        </div>
      </div>
    </div>

  return (
    <>
      <RenderedHtmlContent html={videoRoom.navigationHeader} />
      {navigationOptions?.enabled !== false && navigation}

      <div className="row mt-1 sidebar-content">
        <div className="col sidebar-col">
          {showDownloads && activeTab == "Downloads" && <Downloads/>}
          {showVotings && activeTab == "Voting" && <Voting videoRoom={videoRoom} options={props.votingOptions} votingFormOptions={props.votingFormOptions}/>}
          {activeTab == "Question" &&
            <>
              <HtmlContent identifier={"questions.header"}/>
              { showQuestions &&
                <Question
                  videoRoom={videoRoom}
                  options={props.questionsOptions}
                  showQuestionUpVote={showQuestionUpVote}
                  questionsRepeatNames={questionsRepeatNames}
                  questionsShowCompany={questionsShowCompany}
                  event={activeEvent}/>
              }
              { showQuestionForm &&
                <QuestionForm
                  options={props.questionFormOptions}
                  videoRoom={videoRoom}/>
              }
            </>
          }
          {showAgenda && activeTab == "Agenda" && <Agenda videoRoom={videoRoom} options={props.agendaOptions}/>}
          {showChat && activeTab == "Chat" && <Chat options={chatOptions || {}} videoRoom={videoRoom}/>}
          <AdditionalContentes additionalTabs={props.additionalTabs}/>
        </div>
      </div>
    </>
  );
}
